import React from "react"
import { Box, Tooltip } from "@chakra-ui/react"
import Icon from "components/elements/Icon"

const FallbackIcon = ({ note }: { note: string }) => (
  <Tooltip label={note} placement="top" hasArrow>
    <Box as="span" role="img" color="orange.500" lineHeight={0} tabIndex={0} aria-label={note}>
      <Icon icon="form-waitlist" size={4} />
    </Box>
  </Tooltip>
)

export default FallbackIcon
